import { render, staticRenderFns } from "./sms-message-list.vue?vue&type=template&id=518e26fc"
import script from "./sms-message-list.vue?vue&type=script&lang=js"
export * from "./sms-message-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518e26fc')) {
      api.createRecord('518e26fc', component.options)
    } else {
      api.reload('518e26fc', component.options)
    }
    module.hot.accept("./sms-message-list.vue?vue&type=template&id=518e26fc", function () {
      api.rerender('518e26fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/sms-message-list.vue"
export default component.exports